import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwareListRoute: InvariantJiraRoute = {
	name: 'software-list',
	path: '/jira/software/projects/:projectKey/list',
};
